import {
  FETCH_ENTRIES_MAP,
  FETCH_ENTRIES_MAP_FULFILLED,
  FETCH_ENTRIES_MAP_REJECTED,
} from 'b2b-apps/shop/content/redux/entriesMap/actionTypes';
import {
  EntryMapType,
  FetchEntriesMapAction,
  FetchEntriesMapFulfilledAction,
  FetchEntriesMapRejectedAction,
} from 'b2b-apps/shop/content/redux/entriesMap/types';

const fetchEntriesMap = (): FetchEntriesMapAction => ({
  type: FETCH_ENTRIES_MAP,
});

const fetchEntriesMapFulfilled = (
  response: EntryMapType[],
): FetchEntriesMapFulfilledAction => ({
  type: FETCH_ENTRIES_MAP_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchEntriesMapRejected = (
  error: ErrorType,
): FetchEntriesMapRejectedAction => ({
  type: FETCH_ENTRIES_MAP_REJECTED,
  payload: {
    error,
  },
});

export {
  fetchEntriesMap,
  fetchEntriesMapFulfilled,
  fetchEntriesMapRejected,
};
